module.exports = __webpack_public_path__ + "img/top.3a85c4d7.svg";